import { RArray } from "../../collections";
export class QrWaiterOrderingHours {
    isTakingOnlineOrdersAt(now) {
        return true;
    }
    fulfillmentTimes(date) {
        return RArray.empty();
    }
    endOfDay(date) {
        return null;
    }
}
